export default __webpack_public_path__ + "static/media/yotascale-logo-light-medium.ff308b29.png";